import {getItemOverviewDetails, getSubItemColConfig} from '@/services/Order/orderItemOverview'
import {useQueries} from '@tanstack/react-query'

export const useItemOverview = () => {
  const results = useQueries({
    queries: [
      {queryKey: ['ORDER_ITEM_OVERVIEW'], queryFn: getItemOverviewDetails},
      {queryKey: ['ORDER_ITEM_OVERVIEW_SUBITEM_COL_CONFIG'], queryFn: getSubItemColConfig},
    ],
  })

  return {
    itemOverviewData: results?.[0]?.data || {},
    subItemColConfigData: results?.[1]?.data?.subItemColumnConfig || [],
  }
}
